import { useEffect, useState } from "react";
import { RunRate } from "./RunRate/RunRate";
import BusinessLeaderDashboardFilter from "./BusinessLeaderDashboardFilter/BusinessLeaderDashboardFilter";
import { AdditionalQueries } from "./AdditionalQueries/AdditionalQueries";
import { HighLevelKPI } from "./HighLevelKPI/HighLevelKPI";
import { Alert, Paper } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
//import store from "../../../../store";
//import { setIsLoading } from "../../../../features/userSlice";
import FloatingActionItems from "../../../../pages/FloatingItems/FloatingActionItems";
import { useSearchParams } from "react-router-dom";

interface BuiLeaderDashBoardProps {
  siteOptions: any;
  getAllDimesnionsForViewOrganizationalSummary: any;
  getHighLevelTargetVsActualData: any;
  getlastMonthTargetVsActualData: any;
  getlast7DaysSince2DaysAgoData: any;
  getmtdQftdBudgetControlIdData: any;
  getConversionLoadingPercLast14DaysData: any;
  highLevelTargetActualData: any;
  sethighLevelTargetActualData: any;
  lastMonthTargetVsActualData: any;
  last7DaysSince2DaysAgoData: any;
  mtdQftdBudgetControlIdData: any;
  conversionLoadingPercLast14DaysData: any;
}

function BusinessLeaderDashboard({
  siteOptions,
  getAllDimesnionsForViewOrganizationalSummary,
  getHighLevelTargetVsActualData,
  getlastMonthTargetVsActualData,
  getlast7DaysSince2DaysAgoData,
  getmtdQftdBudgetControlIdData,
  getConversionLoadingPercLast14DaysData,
  highLevelTargetActualData,
  sethighLevelTargetActualData,
  lastMonthTargetVsActualData,
  last7DaysSince2DaysAgoData,
  mtdQftdBudgetControlIdData,
  conversionLoadingPercLast14DaysData,
}: BuiLeaderDashBoardProps) {
  // states for passing to the childrens components
  const [dataShow, setDataShow] = useState(false);
  const [highLevelData, setHighLevelData] = useState() as any;
  const [lastMonthData, setLastMonthData] = useState();
  const [last7DaysData, setLast7DaysData] = useState();
  //const [topKeyWordData, setTopKeyWordData] = useState();
  const [mtdQftdData, setMtdQftdData] = useState();
  const [conversionData, setConversionData] = useState();

  const [collapseAllSections, setCollapseAllSections] = useState(false);
  const [getDataClicked, setGetDataClicked] = useState<boolean>();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    try {
      if (
        highLevelTargetActualData?.query_output?.length >= 0 &&
        getDataClicked
      ) {
        setDataShow(true);
        getlastMonthTargetVsActualData();
        getlast7DaysSince2DaysAgoData();
        getmtdQftdBudgetControlIdData();
        getConversionLoadingPercLast14DaysData();
        setGetDataClicked(false);
        // store.dispatch(setIsLoading(false));
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    }
    // eslint-disable-next-line
  }, [getDataClicked, highLevelData]);

  useEffect(() => {
    try {
      if (
        highLevelTargetActualData?.query_output?.length >= 0 &&
        getDataClicked
      ) {
        setHighLevelData(highLevelTargetActualData?.query_output);
      }
    } catch (error: any) {
      console.error("Error getting BUI dashboard data", error);
    }
    // eslint-disable-next-line
  }, [getDataClicked, highLevelTargetActualData]);

  useEffect(() => {
    if (lastMonthTargetVsActualData?.query_output?.length > 0) {
      setLastMonthData(lastMonthTargetVsActualData?.query_output);
    }
    // eslint-disable-next-line
  }, [lastMonthTargetVsActualData]);

  useEffect(() => {
    if (last7DaysSince2DaysAgoData?.query_output?.length > 0) {
      setLast7DaysData(last7DaysSince2DaysAgoData?.query_output);
    }
    // eslint-disable-next-line
  }, [last7DaysSince2DaysAgoData]);

  useEffect(() => {
    if (mtdQftdBudgetControlIdData?.query_output?.length > 0) {
      setMtdQftdData(mtdQftdBudgetControlIdData?.query_output);
    } else {
      if (mtdQftdBudgetControlIdData?.query_output?.length === 0) {
        setMtdQftdData(mtdQftdBudgetControlIdData?.query_output);
      }
    }
    // eslint-disable-next-line
  }, [mtdQftdBudgetControlIdData]);

  useEffect(() => {
    if (conversionLoadingPercLast14DaysData?.query_output?.length > 0) {
      setConversionData(conversionLoadingPercLast14DaysData?.query_output);
    }
    // eslint-disable-next-line
  }, [conversionLoadingPercLast14DaysData]);

  return (
    <>
      <>
        <BusinessLeaderDashboardFilter
          siteOptions={siteOptions}
          getAllDimesnionsForViewOrganizationalSummary={
            getAllDimesnionsForViewOrganizationalSummary
          }
          getHighLevelTargetVsActualData={getHighLevelTargetVsActualData}
          setCollapseAllSections={setCollapseAllSections}
          setGetDataClicked={setGetDataClicked}
          setHighLevelData={setHighLevelData}
          sethighLevelTargetActualData={sethighLevelTargetActualData}
          setDataShow={setDataShow}
        />
        <>
          {dataShow ? (
            <>
              <Paper>
                {highLevelData?.length > 0 ? (
                  <>
                    <HighLevelKPI highLevelData={highLevelData} />
                    <RunRate highLevelData={highLevelData} />
                  </>
                ) : (
                  <Alert
                    sx={{ color: "#ED6C02", mb: 1 }}
                    severity="warning"
                    icon={
                      <InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} />
                    }
                  >
                    NO DATA FOR Run Rate AND High Level KPI
                  </Alert>
                )}
                <AdditionalQueries
                  setCollapseAllSections={setCollapseAllSections}
                  lastMonthData={lastMonthData}
                  last7DaysData={last7DaysData}
                  mtdQftdData={mtdQftdData}
                  conversionData={conversionData}
                  collapseAllSections={collapseAllSections}
                />
              </Paper>
              <div data-tracker="396">
                {searchParams.get("selectedType") === "site" ? (
                  <FloatingActionItems
                    selectedSiteFloatingAction={
                      searchParams
                        .get("selectedSharedUids")
                        ?.split(",")[0] as string
                    }
                    selectedDimensionsFloatingAction={""}
                    trackIdFloatingAction={"435"}
                  />
                ) : (
                  <FloatingActionItems
                    selectedSiteFloatingAction={""}
                    selectedDimensionsFloatingAction={
                      searchParams
                        .get("selectedDimension")
                        ?.split(",")[0] as string
                    }
                    trackIdFloatingAction={"435"}
                  />
                )}
              </div>
            </>
          ) : (
            ""
          )}
        </>
      </>
    </>
  );
}

export default BusinessLeaderDashboard;
